import React from 'react';
import Head from 'next/head';
import Layout from 'components/Layout/Layout';
import { GetStaticProps } from 'next';
import { getCategoriesForMenu } from 'utils/categoryUtil';
import NotFoundRobot from 'assets/robots/robot-found-error.svg';
import styles from 'styles/FourOhFourPage.module.css';
import SpaLink from 'components/SpaLink/SpaLink';
import { CategoryItem } from 'frontend/types';
interface Props {
  highlightedCategories: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
}
const FourOhFourPage = ({
  highlightedCategories,
  minorityLanguageCategories
}: Props) => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="404.tsx">
        <title>UR Play</title>
      </Head>
      <Layout categories={highlightedCategories} minorityLanguageCategories={minorityLanguageCategories} data-sentry-element="Layout" data-sentry-source-file="404.tsx">
        <div className={styles.pageNotFound}>
          <div data-trk-error-page className={styles.errorContainer}>
            <div className={styles.sectionOne}>
              <div className={styles.robotIconContainer}>
                <NotFoundRobot className={styles.robotIcon} data-sentry-element="NotFoundRobot" data-sentry-source-file="404.tsx" />
              </div>

              <div>
                <h1 className={styles.header}>
                  Hoppsan, nu hamnade du på vår 404-sida*
                </h1>
                <p className={styles.paragraph}>
                  Vi ber om ursäkt för detta, kanske kan det bero på att:
                </p>
                <ul className={styles.list}>
                  <li>Du har klickat på en trasig länk</li>
                  <li>Sidan du försökt nå är borttagen eller finns inte</li>
                </ul>
                <p className={styles.paragraph}>
                  Du kan alltid testa att gå till vår{' '}
                  <SpaLink href="/" className={styles.link} data-sentry-element="SpaLink" data-sentry-source-file="404.tsx">
                    Startsida
                  </SpaLink>{' '}
                  eller{' '}
                  <SpaLink href="/bladdra/alla-program" className={styles.link} data-sentry-element="SpaLink" data-sentry-source-file="404.tsx">
                    Alla program
                  </SpaLink>{' '}
                  för att ta del av våra program.
                </p>
              </div>
            </div>
            <div>
              <h2 className={styles.subHeader}>*Vad är en 404-sida?</h2>
              <p className={styles.paragraphNoMarginBottom}>
                En 404-sida visas för dig när du försöker besöka en sida som
                inte finns eller inte kan hittas. När din dator och en annan
                dator på internet pratar med varandra så använder de koder för
                att berätta om saker som vanligtvis kan hända. De kallas för
                HTTP status koder, det finns många koder som beskriver olika
                saker. Exempelvis betyder 200 att allt har gått bra, 301 att
                någonting har flyttat till en ny plats och 404 att någonting har
                försvunnit och inte längre finns tillgängligt eller aldrig har
                funnits tillgängligt.
              </p>
              <p className={styles.paragraphIndent}>
                Nu vet du mer om vad en 404-sida är och vi hoppas att vi med
                vårt arbete för att skapa den bästa upplevelsen av UR Play kan
                undvika att du hamnar här igen!
              </p>
            </div>
          </div>
        </div>
      </Layout>
    </>;
};
export const getStaticProps: GetStaticProps = async () => {
  const {
    highlightedCategories,
    minorityLanguageCategories
  } = await getCategoriesForMenu();
  return {
    props: {
      highlightedCategories,
      minorityLanguageCategories
    }
  };
};
export default FourOhFourPage;